"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _TagsGroup = _interopRequireDefault(require("../../../../TagsGroup/TagsGroup"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
(function () {
  const styles = ".MasterarbeitTags-container {\n  display: flex;\n  align-items: end;\n  gap: 8px; }\n  .MasterarbeitTags-container .school {\n    padding-bottom: 4px; }\n  .MasterarbeitTags-container .tags-group {\n    display: inline; }\n    .MasterarbeitTags-container .tags-group > div {\n      cursor: pointer; }\n";
  const fileName = "MasterarbeitTags_MasterarbeitTags";
  const element = document.querySelector("style[data-sass-component='MasterarbeitTags_MasterarbeitTags']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const MasterarbeitTags = _ref => {
  let {
    item
  } = _ref;
  const rank = item?.rank && item?.rank.name ? {
    label: item?.rank.name,
    type: 'tertiary'
  } : undefined;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "MasterarbeitTags-container sia-padding-01-bottom"
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "school sia-text-01"
  }, item.school.name), /*#__PURE__*/_react.default.createElement(_TagsGroup.default, {
    items: [rank]
  }));
};
var _default = exports.default = MasterarbeitTags;